/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Height_LabelInputs */



/**
* | output |
* | --- |
* | "Display Height (Lines)" |
*
* @param {Options_Display_Height_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_height_label = /** @type {((inputs?: Options_Display_Height_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Height_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hauteur d'affichage (lignes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigehöhe (Zeilen)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altezza di visualizzazione (linee)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Высота отображения (строк)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Altura de la pantalla (líneas)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示高度（行）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示高さ（行）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिस्प्ले की ऊंचाई (लाइनें)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Altura de exibição (linhas)")
	return /** @type {LocalizedString} */ ("Display Height (Lines)")
});